import { Constants } from "customer-sdk/constants";
const ERROR_MESSAGES = Constants.ERROR_MESSAGES;

export let validateCardHolderNameField = (component) => {
  let errorMessage = errorMessageOnSubmit(component);
  if (errorMessage != null) throw errorMessage;
};

let errorMessageOnSubmit = (component) => {
  if (component.nameOnCard == "") {
    component.nameOnCardInputErrorMessage = ERROR_MESSAGES.CREDIT_CARD.EMPTY_CARDHOLDER_NAME_INPUT;
  } else if (removeWhiteSpace(component.nameOnCard).length < 3) {
    component.nameOnCardInputErrorMessage = ERROR_MESSAGES.CREDIT_CARD.CARDHOLDER_NAME_MIN_INPUT;
  } else if (removeWhiteSpace(component.nameOnCard).length > 25) {
    component.nameOnCardInputErrorMessage = ERROR_MESSAGES.CREDIT_CARD.CARDHOLDER_NAME_MAX_INPUT;
  } else {
    component.nameOnCardInputErrorMessage = null;
  }
  return component.nameOnCardInputErrorMessage;
};

let removeWhiteSpace = (text) => {
  return text.replace(/\s/g, "");
};

let validateNameOnCardInputChange = (component) => {
  let result = false;
  if (component.nameOnCard == "") {
    component.nameOnCardInputErrorMessage = null;
    result = false;
  }
  if (removeWhiteSpace(component.nameOnCard).length < 3) {
    component.nameOnCardInputErrorMessage = ERROR_MESSAGES.CREDIT_CARD.CARDHOLDER_NAME_MIN_INPUT;
    result = true;
  }
  if (removeWhiteSpace(component.nameOnCard).length > 25) {
    component.nameOnCardInputErrorMessage = ERROR_MESSAGES.CREDIT_CARD.CARDHOLDER_NAME_MAX_INPUT;
    result = true;
  }
  component.nameOnCardInputErrorMessage = null;
  return result;
};

export const AddNewCardMixin = {
  computed: {
    isNameOnCardInputInvalid: function () {
      let component = this;
      return validateNameOnCardInputChange(component);
    },
    isNameOnCardInputEmpty: function () {
      let component = this;
      if (component.nameOnCard != "") return false;
      return true;
    },
  },
};
